export const REPORT_SCHEMA_VERSION = 1;
export const REPORT_RENDERER_VERSION = "reports-mvp-v1";
export const REPORT_ITEM_LIMIT = 30;

export const REPORT_ITEM_TYPES = {
  APP_MAP: "app_map",
  TSUNAMI_MAP: "tsunami_map",
  LANDMARKS_MAP: "landmarks_map",
};

export const REPORT_SOURCE_MODULES = {
  APP: "app",
  TSUNAMI: "tsunami",
  LANDMARKS: "landmarks",
};

export const REPORT_ORIENTATIONS = {
  PORTRAIT: "portrait",
  LANDSCAPE: "landscape",
};

export const REPORT_TYPE_CONFIG = {
  [REPORT_ITEM_TYPES.APP_MAP]: {
    label: "Mapa",
    sourceModule: REPORT_SOURCE_MODULES.APP,
    orientations: [REPORT_ORIENTATIONS.PORTRAIT, REPORT_ORIENTATIONS.LANDSCAPE],
    defaultOrientation: REPORT_ORIENTATIONS.LANDSCAPE,
  },
  [REPORT_ITEM_TYPES.TSUNAMI_MAP]: {
    label: "Tsunami mapa",
    sourceModule: REPORT_SOURCE_MODULES.TSUNAMI,
    orientations: [REPORT_ORIENTATIONS.PORTRAIT, REPORT_ORIENTATIONS.LANDSCAPE],
    defaultOrientation: REPORT_ORIENTATIONS.LANDSCAPE,
  },
  [REPORT_ITEM_TYPES.LANDMARKS_MAP]: {
    label: "Místa mapa",
    sourceModule: REPORT_SOURCE_MODULES.LANDMARKS,
    orientations: [REPORT_ORIENTATIONS.LANDSCAPE],
    defaultOrientation: REPORT_ORIENTATIONS.LANDSCAPE,
  },
};

export function getReportTypeConfig(type) {
  return REPORT_TYPE_CONFIG[type] || null;
}

export function getReportTypeLabel(type) {
  return getReportTypeConfig(type)?.label || "Report";
}

export function getAllowedOrientations(type) {
  return getReportTypeConfig(type)?.orientations || [REPORT_ORIENTATIONS.PORTRAIT];
}

export function supportsOrientationToggle(type) {
  return getAllowedOrientations(type).length > 1;
}

export function normalizeReportOrientation(type, orientation) {
  const allowed = getAllowedOrientations(type);
  const requested = String(orientation || "").trim();
  if (allowed.includes(requested)) return requested;
  return getReportTypeConfig(type)?.defaultOrientation || allowed[0] || REPORT_ORIENTATIONS.PORTRAIT;
}

export function getSourceModuleForReportType(type) {
  return getReportTypeConfig(type)?.sourceModule || "";
}
